import { ApolloClient, Reference } from '@apollo/client';

import type { AnswerFragment } from './activity-answers.graphql.generated';
import type {
  GetMyAnswersQuery,
  GetMyAnswersQueryVariables,
} from './activity-answers.graphql.generated';
import { GET_MY_ANSWERS } from './activity-answers.graphql';

export function getAnswerFromCache({
  uuid,
  client,
  variables,
}: {
  uuid: string;
  client: ApolloClient<any>;
  variables: GetMyAnswersQueryVariables;
}) {
  const answersData = client.readQuery<GetMyAnswersQuery>({
    query: GET_MY_ANSWERS,
    variables,
  });
  return answersData?.getMyAnswers.find(a => a.uuid === uuid);
}

export function upsertAnswerInCache({
  answer,
  answers,
  client,
  variables,
}: {
  client: ApolloClient<any>;
  answers: AnswerFragment[];
  answer: AnswerFragment;
  variables: GetMyAnswersQueryVariables;
}) {
  const existingAnswer = getAnswerFromCache({
    client,
    uuid: answer.uuid,
    variables,
  });
  client.writeQuery<GetMyAnswersQuery>({
    query: GET_MY_ANSWERS,
    variables,
    data: {
      getMyAnswers: existingAnswer
        ? [answer, ...answers.filter(a => a.uuid !== answer.uuid)]
        : [answer, ...answers],
    },
  });
}

export function deleteAnswersByComponentIdInCache({
  client,
  componentId,
}: {
  client: ApolloClient<any>;
  componentId: string;
}) {
  const filterByComponentId = (
    existingAnswers: Reference[] = [],
    { readField }: any
  ) => {
    return existingAnswers.filter((answerRef: Reference) => {
      const answerComponentId = readField('componentId', answerRef);
      return answerComponentId !== componentId;
    });
  };

  client.cache.modify({
    id: 'ROOT_QUERY',
    fields: {
      getMyAnswers: filterByComponentId,
    },
  });

  client.cache.gc();
}

export const deleteAllAnswersInCache = ({
  client,
}: {
  client: ApolloClient<any>;
}) => {
  client.cache.evict({
    id: 'ROOT_QUERY',
    fieldName: 'getMyAnswers',
  });
  client.cache.gc();
};
